function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1656.565 -345.126)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1667.08 347.084)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3365.149,943.115a3.134,3.134,0,0,0-.876-.759c-.449-.712-1.475-2.385-1.593-2.57-.146-.231-1.467-4.048-1.467-4.048l-2.553-.484s2.317,4.785,2.7,5.365a11.647,11.647,0,0,0,2.5,2.223h0a4.789,4.789,0,0,0,.234.635,1.88,1.88,0,0,0,.5.4c.035-.013.052-.047.017-.119s-.192-.283-.156-.284.533.581.67.514S3365.3,943.427,3365.149,943.115Z",
  transform: "translate(-3353.328 -930.411)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M3144.278,890.157a7.621,7.621,0,0,0-2.737-.711,1.891,1.891,0,0,0-1.935,1.293c-.016.048-.031.1-.045.148-.378,1.362-.172,5.485,1.1,6.561s3.615.622,3.615.622Z",
  transform: "translate(-3139.135 -885.659)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M3341.083,1325.437s-.137,1.7-.3,3.753c-.218,2.783-1.049,9.718-1.049,9.718s.176.277-.678.1a17.555,17.555,0,0,1-1.266-5.079c0-.045-.006-.089-.01-.134-.2-2.766-.517-8.59-.517-8.59Z",
  transform: "translate(-3332.428 -1311.329)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M3341.13,1309.963s-.183,2.294-.344,4.342l-2.993,4.735c0-.045-.006-.089-.01-.134-.2-2.766-.517-8.59-.517-8.59Z",
  transform: "translate(-3332.428 -1296.444)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M3171.127,1296.5l-6.979,13.283s-.65.292-.734.038c0,0,.619-6.086,1.7-7.451a10.267,10.267,0,0,0,1.366-3.9c.033-.809.219-2.412.219-2.412Z",
  transform: "translate(-3162.602 -1282.869)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 26.362)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3131.055,1867.075s-1.012.014-1.306-.273a2.637,2.637,0,0,1-.147-.377.388.388,0,0,0-.269-.222c-.137-.046-.252-.044-.384-.1a3.546,3.546,0,0,1-.376-.183c-.313-.183-.242-.28-.242-.28s.069-.063.16-.154c.024-.025.051-.052.078-.081a1.5,1.5,0,0,0,.326-.457.441.441,0,0,1,.154-.229.418.418,0,0,1,.144-.075s.111.444.329.389c.424-.107.5-.095.518-.088l0,0s.346.671.442.91a1.851,1.851,0,0,0,.53.728.377.377,0,0,1,.078.115A.341.341,0,0,1,3131.055,1867.075Z",
  transform: "translate(-3128.322 -1864.648)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M3131.055,1899.175s-1.012.015-1.306-.273a2.638,2.638,0,0,1-.147-.377.388.388,0,0,0-.269-.222c-.137-.046-.252-.044-.384-.1a3.524,3.524,0,0,1-.376-.183c-.313-.183-.242-.28-.242-.28s.069-.062.16-.154c.024-.025.051-.052.078-.081a.637.637,0,0,0,.367.453,1.884,1.884,0,0,1,.826.55c.109.186.179.352.391.422a2.833,2.833,0,0,0,.8.071c.031-.015.061-.152.14-.2A.342.342,0,0,1,3131.055,1899.175Z",
  transform: "translate(-3128.322 -1896.748)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.167 27.273)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_23569",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 23569",
  d: "M3395.013,1905.517h.418c.141-.022.244-.063.388-.082a.386.386,0,0,1,.339.082l0,0h1.779c.044-.064,0-.212-.04-.321a.253.253,0,0,0-.167-.152,1.917,1.917,0,0,1-.9-.412c-.192-.173-.926-.637-.926-.637h0c-.016,0-.093.024-.426.306-.172.145-.467-.206-.467-.206a.418.418,0,0,0-.1.131.44.44,0,0,0-.038.273,1.769,1.769,0,0,1-.127.66c-.042.122-.077.208-.077.208S3394.653,1905.472,3395.013,1905.517Z",
  transform: "translate(-3394.673 -1903.999)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_23570",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 23570",
  d: "M3395.015,1954.623h.417c.14-.022.245-.069.389-.088a.39.39,0,0,1,.339.082l0,0h1.779c.045-.064,0-.212-.04-.321-.054-.048-.07.209-.1.25a7.948,7.948,0,0,1-1.534-.045.858.858,0,0,0-.671-.082,1.624,1.624,0,0,1-.848-.161c-.042.122-.076.209-.076.209S3394.655,1954.578,3395.015,1954.623Z",
  transform: "translate(-3394.674 -1953.099)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M3338.765,823.507a4.746,4.746,0,0,0,2.63.516,2.3,2.3,0,0,0-.65-.53c.023-.14.042-.268.057-.382a5.985,5.985,0,0,0,.055-.648l-1.021-.823-.229-.185a2.882,2.882,0,0,1-.031.543c0,.013,0,.026-.006.039A2.413,2.413,0,0,1,3338.765,823.507Z",
  transform: "translate(-3333.892 -819.246)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M3297.677,902.658c-.005.106.213.223.308.265a8.1,8.1,0,0,0,1.241.454,5.472,5.472,0,0,0,.893.162,15.648,15.648,0,0,0,2.309-.1.158.158,0,0,0,.1-.039c.024-.019.043-1.109.024-2.484,0-.053,0-.111,0-.164v-.019c0-.536-.024-1.1-.048-1.659a18.734,18.734,0,0,0-.314-3.088,3.329,3.329,0,0,0-1.042-1.664l-.288-.286a.077.077,0,0,0-.069-.021,1.592,1.592,0,0,1-1.013-.112c-.382-.188-.8-.391-.864-.342-.791.591-1.185,2.337-1.177,4.323,0,.063,0,.126,0,.189,0,.2.011.412.022.621a26.639,26.639,0,0,1-.052,3.473C3297.691,902.373,3297.68,902.542,3297.677,902.658Z",
  transform: "translate(-3293.756 -889.67)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.77 9.963)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.185,0h0A.185.185,0,0,1,.371.185V.241A.185.185,0,0,1,.185.427h0A.185.185,0,0,1,0,.241V.185A.185.185,0,0,1,.185,0Z",
  transform: "translate(0.878 0.355) rotate(-73.469)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M3422.158,1163.047l-.658-.2a.223.223,0,0,0-.277.15l-.514,1.733a.223.223,0,0,0,.15.277l.658.2a.223.223,0,0,0,.276-.15l.515-1.733A.223.223,0,0,0,3422.158,1163.047Z",
  transform: "translate(-3420.699 -1162.692)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M3421.2,1172.749l-.493,1.663a.223.223,0,0,0,.15.277l.658.2a.223.223,0,0,0,.276-.15l.484-1.629a1.464,1.464,0,0,0-.482-.089A1.389,1.389,0,0,1,3421.2,1172.749Z",
  transform: "translate(-3420.699 -1172.37)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.134,
  height: 1.132,
  transform: "translate(0.134 1.621) rotate(-73.46)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M3297.677,1008.4c-.005.106.213.223.308.265a8.143,8.143,0,0,0,1.241.454,12.444,12.444,0,0,0-.228-7.323l-1.262,2.012c0,.205.011.412.022.621a26.639,26.639,0,0,1-.052,3.473C3297.691,1008.113,3297.68,1008.281,3297.677,1008.4Z",
  transform: "translate(-3293.756 -995.41)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M3284.456,896.089a5.476,5.476,0,0,0-1.926-.758.223.223,0,0,1-.182-.311,5.155,5.155,0,0,1,1.572-2.009c.07-.045.123-.006.2.035a1.743,1.743,0,0,1,.9,1.147,7.8,7.8,0,0,1-.23,1.753A.223.223,0,0,1,3284.456,896.089Z",
  transform: "translate(-3278.763 -889.126)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M3373.154,829.812l.008.015a2.373,2.373,0,0,0,1.232,1.074,6.089,6.089,0,0,0,.055-.648l-1.021-.823a2.9,2.9,0,0,0-.26.359Z",
  transform: "translate(-3367.485 -827.036)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M3361.566,752.94s-1.591.264-1.74-.729-.455-1.628.555-1.839,1.263.139,1.395.458S3361.977,752.845,3361.566,752.94Z",
  transform: "translate(-3354.307 -749.746)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M3335.084,726.572c-.33-.152-1.939-.916-2.629-.219a1.979,1.979,0,0,1-.01-.233.912.912,0,0,0-.083.319.3.3,0,0,0-.176-.086.245.245,0,0,1,.131.174c-.683,1.016.354,2.05.5,2.211s.231.117.231.117.26-.352.134-.583c0,0-.211-.213-.089-.348s.192.07.288.064.269-.288.281-.544.937.135,1.308.013S3335.665,726.84,3335.084,726.572Z",
  transform: "translate(-3327.369 -726.064)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.834 4.13)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3294.022,909.593l-.049-.3a2.7,2.7,0,0,0,1.774-1.053,3.425,3.425,0,0,0,.641-1.571c.146-1.088-.14-1.707-.876-1.893a2.1,2.1,0,0,0-1.427.353l-.174-.253a2.373,2.373,0,0,1,1.677-.4c.62.157,1.314.671,1.1,2.232a3.71,3.71,0,0,1-.7,1.716A2.991,2.991,0,0,1,3294.022,909.593Z",
  transform: "translate(-3293.91 -904.431)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M3248.132,998.416c-.038-.147-.553-.029-.662-.139-.026-.025.24-.045.317-.066s.092-.055.079-.09a1.887,1.887,0,0,0-.632-.118,3.222,3.222,0,0,0-.479.17v0s-2.02-1.461-2.375-1.817c-.26-.256,1.26-2.339,1.236-2.353a5.491,5.491,0,0,0-1.926-.762.176.176,0,0,1-.075-.018,11.054,11.054,0,0,0-1.047,3.656,7.855,7.855,0,0,0,3.892,1.972,7.317,7.317,0,0,0,1.186.19A.508.508,0,0,0,3248.132,998.416Z",
  transform: "translate(-3239.923 -987.036)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1657.069 351.414)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2807.115,913.574c-.015-.053-.21-.656-1.151-.456,0,0,.471-.059.6.122a.773.773,0,0,0-.607-.028c-.234.143-.272.625-.237.771s.293.583.464.583a.51.51,0,0,0,.2-.048,2.24,2.24,0,0,0-.069.254c-.182.854.386,1.5.68,1.343.188-.1.331.227.331.227l1.563-2.072S2807.8,912.96,2807.115,913.574Z",
  transform: "translate(-2803.17 -913.077)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2925.371,1193.63c-.042.159-.178.517-.284.517-.086,0-.117-.439-.228-.533a1.347,1.347,0,0,1-.312-.487c-.043-.142-.083-.171-.083-.171h0a21.176,21.176,0,0,1-1.385-2.949c-.033-.2-.117-.588-.215-1.028-.108-.478-.232-1.012-.326-1.412a7.4,7.4,0,0,1,1.234-.115c.075.486.143.984.2,1.416.087.642.152,1.141.193,1.248.112.293.419,1.873.709,2.694a.97.97,0,0,0,.231.362C2925.232,1193.26,2925.412,1193.471,2925.371,1193.63Z",
  transform: "translate(-2917.292 -1181.099)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2728.318,1088.564c.035.084.185.158.4.212a3.637,3.637,0,0,0,1.9-.084c.64-.237,1.1-3.619,1.3-5.352.069-.6.105-1.009.105-1.009s-.367-.575-1.79-.384-1.566.671-1.694,1.534A40.118,40.118,0,0,0,2728.318,1088.564Z",
  transform: "translate(-2727.539 -1077.999)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2708.3,1053.374c-.709-2.268.068-2.761-.006-3.9a5.5,5.5,0,0,0-.953-2.355l-.121-.011c-.058-.031-.074-.278-.074-.538,0-.312.025-.644.025-.644l-1.054-.208-.063-.012a2.017,2.017,0,0,1-.33,1.327,4.566,4.566,0,0,0-1.039.23.49.49,0,0,0-.265.2,20.153,20.153,0,0,0-.781,3.388c-.113.638-.2,1.134-.244,1.239-.124.288-.5,1.854-.822,2.662a.972.972,0,0,1-.246.352c-.133.084-.321.286-.286.447s.07.411.237.411c.073,0,.187-.139.3-.308.075.042.092-.083.175-.156s.134-.416.134-.416c.049-.139.091-.167.091-.167h0a21.133,21.133,0,0,0,1.507-2.889c.041-.194.142-.583.259-1.018l.054-.2a3.321,3.321,0,0,1,.307,1.064,6.885,6.885,0,0,1-.731,1.753C2704.1,1054.229,2709.022,1055.69,2708.3,1053.374Z",
  transform: "translate(-2701.896 -1042.638)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2879.318,1046.451s-.024.332-.025.644a1.249,1.249,0,0,1-1.029-.853Z",
  transform: "translate(-2874.044 -1043.159)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2857.017,949.946a3.094,3.094,0,0,1-.383-.906,1.064,1.064,0,0,1,1.209-1.244,1.507,1.507,0,0,1,.625.237c.241.163.589.514.2,1.478l-.1.326Z",
  transform: "translate(-2852.906 -946.978)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2872.718,968.713s-1.4.023-1.4-.846-.182-1.451.709-1.5,1.064.28,1.135.57S2873.081,968.685,2872.718,968.713Z",
  transform: "translate(-2867.247 -965.126)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2875.784,1405.335l-.447.11a13.784,13.784,0,0,1-1.289-2.28,8.385,8.385,0,0,1-.759-2.669,3.439,3.439,0,0,1,.09-1.142s-.125-.841-.3-1.964c-.19-1.248-.437-2.844-.63-4.017l.116-.035,2.5-.742a16.757,16.757,0,0,1,.265,4.914c-.046.616-.122,1.277-.238,1.976a10.577,10.577,0,0,0,.048,3.4A13.066,13.066,0,0,0,2875.784,1405.335Z",
  transform: "translate(-2868.368 -1381.495)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2875.333,1397.511l-2.043,2.986a3.439,3.439,0,0,1,.09-1.142s-.125-.841-.3-1.964c-.19-1.248-.437-2.844-.63-4.017l.116-.035,2.5-.742A16.757,16.757,0,0,1,2875.333,1397.511Z",
  transform: "translate(-2868.368 -1381.495)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2730.942,1383.866c-.088.166-.967,1.222-1.848,2.39-.075.1-.154.208-.234.321-.52.732-1.118,1.686-1.475,2.151-.325.422-.617-.106-.453-.484.258-.6.478-1.636.728-2.4a4.878,4.878,0,0,1,.179-.478,7.214,7.214,0,0,1,1.434-1.918c.111-.113-.927-2.822-.858-4.91a4.5,4.5,0,0,1,.406-2l2.625.13S2731.806,1382.245,2730.942,1383.866Z",
  transform: "translate(-2726.17 -1365.806)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2854.2,958.967c-.216-.261-.378-.2-.47-.126a.99.99,0,0,0-1.255.2,1.658,1.658,0,0,1-.543.981,1.154,1.154,0,0,0,.84.006.993.993,0,0,0,.474-.327,3.264,3.264,0,0,1-.56.684,2.323,2.323,0,0,0,1.009-1.4,1.09,1.09,0,0,1,.305.406c.069.221.1.677.233.661C2854.237,960.052,2854.524,959.359,2854.2,958.967Z",
  transform: "translate(-2848.324 -957.642)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2766.1,1111.929a.625.625,0,0,0,.016.21c.056.176.248.256.711.208.283-.029.41-.5.466-.91q.255.87.716.974c.449.1,2.717.376,2.865-.7a33.79,33.79,0,0,0-.353-4.417,5.589,5.589,0,0,0,.082-1.049,2.143,2.143,0,0,0-.437-1.44.62.62,0,0,0-.31-.1c-.106-.018-.252-.039-.46-.066,0,0-.089-.011-.087-.008.038.069.451.676.411.876s-1.628.179-1.754.064a5.86,5.86,0,0,1-.453-.983,2.518,2.518,0,0,0-.96.3l0,0a.277.277,0,0,0-.083.087,18.048,18.048,0,0,0-.909,3.412,1.678,1.678,0,0,0,1.229.18C2766.587,1109.9,2766.126,1111.324,2766.1,1111.929Z",
  transform: "translate(-2763.951 -1100.152)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2931.11,1106.8l0,0a8.127,8.127,0,0,1,1.122,2.65,5.613,5.613,0,0,0,.083-1.049,7.164,7.164,0,0,0-.973-1.574A.871.871,0,0,0,2931.11,1106.8Z",
  transform: "translate(-2925.667 -1102.317)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2941.343,1837.212a13.8,13.8,0,0,0,1.289,2.28l.448-.11a13.028,13.028,0,0,1-.642-2.45A2.093,2.093,0,0,1,2941.343,1837.212Z",
  transform: "translate(-2935.663 -1815.541)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.366 23.344)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2971.215,1922.432h.306c.1-.016.179-.046.284-.059a.285.285,0,0,1,.249.059l0,0h1.3c.033-.047,0-.155-.03-.235a.186.186,0,0,0-.122-.111,1.405,1.405,0,0,1-.659-.3c-.14-.127-.678-.466-.678-.466h0c-.012,0-.068.017-.312.224-.126.106-.341-.15-.341-.15a.31.31,0,0,0-.071.1.329.329,0,0,0-.028.2,1.3,1.3,0,0,1-.093.483c-.031.089-.056.153-.056.153S2970.951,1922.4,2971.215,1922.432Z",
  transform: "translate(-2970.966 -1921.32)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2971.215,1958.392h.306c.1-.016.179-.046.284-.06a.285.285,0,0,1,.249.06l0,0h1.3c.033-.047,0-.155-.03-.235-.039-.035-.051.153-.072.183a5.8,5.8,0,0,1-1.123-.033.628.628,0,0,0-.492-.06,1.186,1.186,0,0,1-.621-.117c-.031.089-.056.153-.056.153S2970.951,1958.359,2971.215,1958.392Z",
  transform: "translate(-2970.966 -1957.28)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M2788.67,1227.261a2.731,2.731,0,0,0,1.191-1,3,3,0,0,0-.047-3.608c-.156-.036-.449,1.249-.449,1.249C2789.162,1225.23,2788.7,1226.656,2788.67,1227.261Z",
  transform: "translate(-2786.525 -1215.484)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2798.5,1099.471a3.613,3.613,0,0,1,1.375,2.717,2.1,2.1,0,0,1-1.566,2.222l.107-.584a1.629,1.629,0,0,0,1-1.958A4.3,4.3,0,0,0,2798,1099.6Z",
  transform: "translate(-2795.642 -1095.155)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2914.966,1042.813s.027.107.293.087c0,0,.224-.016.216-.134A.721.721,0,0,0,2914.966,1042.813Z",
  transform: "translate(-2909.896 -1039.739)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2728.86,1779.189c-.52.732-1.118,1.686-1.475,2.151-.325.422-.617-.107-.453-.484.258-.6.478-1.636.728-2.4A1.813,1.813,0,0,0,2728.86,1779.189Z",
  transform: "translate(-2726.17 -1758.418)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 22.435)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2697.907,1884.071s-.765-.1-.955-.343a2.084,2.084,0,0,1-.072-.3.293.293,0,0,0-.179-.2c-.1-.049-.185-.06-.279-.113a2.708,2.708,0,0,1-.264-.177c-.218-.171-.153-.236-.153-.236s.059-.04.136-.1l.067-.053a1.136,1.136,0,0,0,.293-.31.332.332,0,0,1,.14-.156.319.319,0,0,1,.116-.042s.037.346.207.328c.33-.036.388-.019.4-.012l0,0s.19.541.237.732a1.41,1.41,0,0,0,.323.6.284.284,0,0,1,.046.094A.26.26,0,0,1,2697.907,1884.071Z",
  transform: "translate(-2695.996 -1882.047)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2697.907,1905.477s-.765-.1-.955-.343a2.091,2.091,0,0,1-.072-.3.293.293,0,0,0-.179-.2c-.1-.049-.185-.06-.279-.113a2.688,2.688,0,0,1-.264-.178c-.218-.171-.153-.236-.153-.236s.059-.04.136-.1l.067-.052a.485.485,0,0,0,.228.379,1.434,1.434,0,0,1,.564.5c.062.151.1.284.25.359a2.155,2.155,0,0,0,.6.137c.025-.008.062-.108.126-.136A.26.26,0,0,1,2697.907,1905.477Z",
  transform: "translate(-2695.996 -1903.454)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}))));

var SvgTourism = function SvgTourism(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tourism",
    className: "fill",
    width: 22.935,
    height: 31.259,
    viewBox: "0 0 22.935 31.259",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTourism, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tourism.62f1f749.svg";
export { ForwardRef as ReactComponent };